import { combineReducers } from '@reduxjs/toolkit'
import automation from './automation'
import projects from './projects'
import element from './element'
import templateFields from './template_fields'
import elementsOrder from './elements_order'
import report from './report'
import reports from './reports'
import rentList from './rent_list'
import warehouseRentList from './warehouse_rent_list'
import common_element_tag from './tag'
import survey from './survey'
import dictionaries from './dictionaries'
import campaigns from './campaigns'
import campaignPostorders from './campaign_postorders'
import overview from './overview'
import uploaderOptions from './uploader_options'
import formBuilder from './form_builder'
import uploader from './uploader'
import manualPages from './manual_pages'
import multiStep from './multi_step'
import sharingLinks from './sharing_links'
import twoFactorSetup from './two_factor/setup'

const requestsReducer = (state = {}, action) => {
  const { type } = action
  const matches = /(.*)_(REQUEST|SUCCESS|FAILURE)/.exec(type)

  if (!matches) return state

  const [, requestName, requestState] = matches

  const reqStatus = state[requestName] || {}

  switch (requestState) {
    case 'REQUEST':
      return {
        ...state,
        [requestName]: {
          isFetching: true,
          error: null
        }
      }
    case 'SUCCESS':
      return {
        ...state,
        [requestName]: {
          isFetching: false,
          error: null
        }
      }
    case 'FAILURE':
      if (process.env.NODE_ENV !== 'production') { console.error(action.error) }
      return {
        ...state,
        [requestName]: {
          isFetching: false,
          error: action.error || 'REQUEST IS FAILURE'
        }
      }
    default:
      return state
  }
}

const rootReducer = combineReducers({
  requestsStatus: requestsReducer,
  automation,
  projects,
  element,
  templateFields,
  elementsOrder,
  report,
  reports,
  rentList,
  warehouseRentList,
  survey,
  common_element_tag,
  dictionaries,
  campaigns,
  campaign_postorders: campaignPostorders,
  overview,
  uploaderOptions,
  formBuilder,
  uploader,
  manualPages,
  multiStep,
  sharingLinks,
  twoFactorSetup
})

export default rootReducer